import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgChartMetrics = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	...props,
	children: [
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("style", { children: ".a,.b{fill:none;}.b{stroke:currentColor;stroke-linecap:round;stroke-linejoin:round;stroke-width:1.5px;}.fill-none{fill:none !important;}" }) }),
		/* @__PURE__ */ _jsx("path", {
			className: "a",
			d: "M0,0H24V24H0Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "b",
			d: "M16,9V7H14"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "b fill-none",
			d: "M5.778,3H18.222A1.9,1.9,0,0,1,20,5V19a1.9,1.9,0,0,1-1.778,2H5.778A1.9,1.9,0,0,1,4,19V5A1.9,1.9,0,0,1,5.778,3Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "b",
			d: "M8,13.5h8"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "b",
			d: "M8,17h4"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "b fill-none",
			d: "M16,7l-3,3L10.286,8,8,10"
		})
	]
});
export default SvgChartMetrics;
